export default __webpack_public_path__ + "static/media/Code typing-bro.7421c22b.svg";